<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row">
          <div class="col-md-12">
              <div class="top-list-small-toolbar">
                  <div>
                      <h4 class="text-primary">Manufacture Product Summary</h4>
                      <div class="form-inline">
                        <span><b>Company:</b></span>
                        <select v-model="company_no" class="form-control">
                          <option value="">-- All --</option>
                          <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                        </select>
                        <span><b>Type:</b></span>
                        <select v-model="type" class="form-control">
                            <option value="">-- All --</option>
                            <option v-for="i in manufactureTypeList" :key="i.id" :value="i.id">{{ i.name }}</option>
                        </select>
                        <span><b>Date:</b></span>
                        <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                        <button type="button" class="btn btn-sm  btn-hard-primary waves-light waves-effect" @click="refreshList">
                          <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                        </button>
                        <button type="button" class="btn btn-sm  btn-hard-primary waves-light waves-effect" @click="processCheck">
                          <i class="fa fa-refresh" aria-hidden="true"></i> Process
                        </button>
                        <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i class="fa fa-print" aria-hidden="true"></i> Print
                        </button>
                        <div class="dropdown-menu" aria-labelledby="print">
                          <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                          <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="row card-list">
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Product</span></h5>
                <h3 class="my-3">
                  <!-- <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span> -->
                  <span>
                    {{ totalProduct | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Material</span></h5>
                <h3 class="my-3">
                  <!-- <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span> -->
                  <span>
                    {{ totalMaterial | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
              <div class="card">
                  <div class="card-body">
                    <ul class="nav nav-tabs nav-bordered">
                      <li class="nav-item">
                        <a href="#general" data-toggle="tab" aria-expanded="false" class="nav-link active">Material</a>
                      </li>
                      <li class="nav-item">
                        <a href="#non-cost" data-toggle="tab" aria-expanded="false" class="nav-link">Film (non-cost)</a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div class="tab-pane active" id="general">
                        <div class="table-responsive">
                          <table class="table table-item mb-0 table-sm table-striped table-hover">
                              <thead>
                                <th>
                                  <label class="form-checkbox">
                                    <input type="checkbox" v-model="selectAll" @click="select"><i class="form-icon"></i>
                                  </label>
                                </th>
                                <th>No</th>
                                <th>Date</th>
                                <th>Manufacture No.</th>
                                <th>Status</th>
                                <th>Product</th>
                                <th>Type</th>
                                <th class="text-center">Qty</th>
                                <th>Uom</th>
                                <th class="text-right">HPP</th>
                                <th class="text-right">Total</th>
                                <th>Material</th>
                                <th>Category</th>
                                <th class="text-center">Qty</th>
                                <th>Uom</th>
                                <th class="text-right">HPP</th>
                                <th class="text-right">Total</th>
                              </thead>
                              <tbody>
                                  <tr v-for="i in filterData" :key="i.id">
                                    <td>
                                      <label class="form-checkbox">
                                        <input type="checkbox" :value="i.id" v-model="selected"><i class="form-icon"></i>
                                      </label>
                                    </td>
                                    <td v-if="i.level === 1" class="table-top-border">{{ i.no }}</td>
                                    <td v-else>{{ i.no }}</td>

                                    <td v-if="i.level ===1" class="table-top-border">{{ i.manufacture_date | dateFormat('DD/MM/YYYY') }}</td>
                                    <td v-else>&nbsp;</td>

                                    <td v-if="i.level === 1" class="table-top-border"><span class="text-ref-sales" @click="showManufactureNo(i.manufacture_no)" data-toggle="modal" data-target="#modalManufactureForm" data-backdrop="static" data-keyboard="false"><span v-if="i.level === 1">{{ i.manufacture_no2 }}</span></span></td>
                                    <td v-else>&nbsp;</td>

                                    <td v-if="i.level === 1" class="table-top-border">{{ i.status }}</td>
                                    <td v-else>&nbsp;</td>

                                    <td v-if="i.level === 1" class="table-top-border">{{ i.mproduct }}</td>
                                    <td v-else>&nbsp;</td>

                                    <td v-if="i.level === 1" class="table-top-border">
                                      <span class="badge badge-success" v-if="i.type === 'Produksi Fiber'">{{ i.type }}</span>
                                      <span class="badge badge-primary" v-else-if="i.type === 'Produksi Pintu'">{{ i.type }}</span>
                                      <span class="badge badge-warning" v-else-if="i.type === 'Produksi Pintu Setengah Jadi'">{{ i.type }}</span>
                                    </td>
                                    <td v-else>&nbsp;</td>

                                    <td v-if="i.level === 1" class="table-top-border">{{ i.mproduct_qty }}</td>
                                    <td v-else>&nbsp;</td>

                                    <td v-if="i.level === 1" class="table-top-border">{{ i.mproduct_uom }}</td>
                                    <td v-else>&nbsp;</td>

                                    <td v-if="i.level === 1" class="text-right table-top-border">{{ i.mproduct_price | currency }}</td>
                                    <td v-else>&nbsp;</td>

                                    <td v-if="i.level === 1" class="text-right table-top-border">{{ i.mproduct_total | currency }}</td>
                                    <td v-else>&nbsp;</td>

                                    <td v-if="i.level === 1" class="table-top-border">{{ i.product}}</td>
                                    <td v-else>{{ i.product }}</td>

                                    <td v-if="i.level === 1" class="table-top-border">
                                      <span class="badge badge-success" v-if="i.category_id === 'order'">{{ i.category_id }}</span>
                                      <span class="badge badge-warning" v-else-if="i.category_id === 'additional'">{{ i.category_id }}</span>
                                      <span class="badge badge-danger" v-else>{{ i.category_id }}</span>
                                    </td>
                                    <td v-else>
                                      <span class="badge badge-success" v-if="i.category_id === 'order'">{{ i.category_id }}</span>
                                      <span class="badge badge-warning" v-else-if="i.category_id === 'additional'">{{ i.category_id }}</span>
                                      <span class="badge badge-danger" v-else>{{ i.category_id }}</span>
                                    </td>

                                    <td v-if="i.level === 1" class="text-center table-top-border">{{ i.qty }}</td>
                                    <td v-else class="text-center">{{ i.qty }}</td>

                                    <td v-if="i.level === 1" class="table-top-border">{{ i.uom_id }}</td>
                                    <td v-else>{{ i.uom_id }}</td>

                                    <td v-if="i.level === 1" class="text-right table-top-border">{{ i.price | currency }}</td>
                                    <td v-else class="text-right">{{ i.price | currency }}</td>

                                    <td v-if="i.level === 1" class="text-right table-top-border">{{ i.total_cogs | currency }}</td>
                                    <td v-else class="text-right">{{ i.total_cogs | currency }}</td>
                                  </tr>
                              </tbody>
                              <tfoot>
                              </tfoot>
                          </table>
                        </div>
                      </div>
                      <div class="tab-pane" id="non-cost">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <table class="table table-item mb-0 table-sm table-striped table-hover">
                                <thead>
                                  <th>Type</th>
                                  <th>Manufacture No</th>
                                  <th>Date</th>
                                  <th>Status</th>
                                  <th>Product</th>
                                  <th>Ukuran Potong</th>
                                  <th>Qty</th>
                                  <th>Uom</th>
                                </thead>
                                <tbody>
                                  <tr v-for="n in groupNonCost" :key="n.id">
                                    <td>{{ n.type }}</td>
                                    <td>
                                      <span class="text-ref-sales" @click="showManufactureNo(n.manufacture_no)" data-toggle="modal" data-target="#modalManufactureForm" data-backdrop="static" data-keyboard="false">{{ n.manufacture_no2 }}</span>
                                    </td>
                                    <td>{{ n.manufacture_date | dateFormat('DD/MM/YYYY') }}</td>
                                    <td>{{ n.status }}</td>
                                    <td><b>[{{ n.product_no }}]</b> {{ n.product }}</td>
                                    <td>{{ n.hand_qty }} {{ n.hand_uom_id }}</td>
                                    <td>{{ n.qty }}</td>
                                    <td>{{ n.uom_id }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <!-- <div class="col-md-6"><pre>{{ groupNonCost }}</pre></div> -->
                          <!-- <div class="col-md-6"><pre>{{ dataNonCost }}</pre></div> -->
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
        </div>
        <!-- <pre>{{ selected }}</pre>
        <pre>{{ dataRaw }}</pre> -->
        <ManufactureFormModal />
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { manufactureUrl, getHeader, manufacture2Url } from '@/config'
import DatePicker from 'vue2-datepicker'
import ManufactureFormModal from '@/components/manufacture/ManufactureFormModal.vue'

export default {
  name: 'ManufactureReportSummaryProduct',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker,
    ManufactureFormModal
  },
  data () {
    var date = new Date()
    return {
      selectAll: false,
      type: '',
      selected: [],
      startDate: [date, date],
      term: 0,
      salesman_id: '',
      company_no: '',
      year: '2022',
      date: null,
      typeData: null,
      period: [],
      dataRaw: [],
      dataNonCost: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getManufactureTypeList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      manufactureTypeList: state => state.manufactures.manufactureTypeList
    }),
    groupNonCost () {
      var result = []
      if (this.dataNonCost.length > 0) {
        this.dataNonCost.reduce(function (res, value) {
          // var date = new Date(value.hand_date).getTime()
          var key = value.manufacture_no + value.product_no + value.hand_qty
          if (!res[key]) {
            res[key] = {
              check_process: value.check_process,
              no: value.no,
              level: value.level,
              mproduct_check: value.mproduct,
              manufacture_date: value.manufacture_date,
              manufacture_no: value.manufacture_no,
              manufacture_no2: value.manufacture_no2,
              material_manufacture_no: value.material_manufacture_no,
              type_id: value.type_id,
              type: value.type,
              product_no: value.product_no,
              product: value.product,
              qty: parseFloat(value.qty),
              uom_id: value.uom_id,
              category_id: value.category_id,
              price: value.price,
              total_cogs: value.total_cogs,
              hand_id: value.hand_id,
              hand_qty: value.hand_qty,
              hand_uom_id: value.hand_uom_id,
              hand_date: value.hand_date,
              status: value.status
            }
            result.push(res[key])
          } else {
            res[key].qty = parseFloat(res[key].qty) + parseFloat(value.qty)
            res[key].level = value.level
          }
          return res
        }, {})
      }
      return result
    },
    totalProduct () {
      var sum = 0
      var array = this.dataRaw.filter(d => d.level === 1)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].mproduct_total)
      }
      return sum
    },
    totalMaterial () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_cogs)
      }
      return sum
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      })
    }
  },
  methods: {
    async processCheck () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selected
      for (let i = 0; i < array.length; i++) {
        await axios.post(manufactureUrl + '/process-check', { id: array[i] }, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Manufacture', 'Success Process Check Manufature', 'success')
    },
    showManufactureNo (no) {
      var payload = {
        manufacture_no: no
      }
      this.$store.commit('SET_MANUFACTURE_BY_NO', payload)
      this.$store.dispatch('getManufactureByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      this.selected = []
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no,
        type_id: this.type
      }
      await axios.post(manufactureUrl + '/product-summary-detail', obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          for (let i = 0; i < this.dataRaw.length; i++) {
            if (this.dataRaw[i].check_process === true) {
              console.log('dataRaw: ')
              console.log(this.dataRaw[i])
              this.selected.push(this.dataRaw[i].id)
            }
          }
          this.dataNonCost = response.data.non_cost
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: this.dataRaw
      }
      console.log(data)
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await axios.post(manufacture2Url + '/summary-product', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style scoped>
.header-period {
    background-color: #6FB56F;
    color: white;
}
.text-ref-sales {
    color: #28A745;
    cursor: pointer;
    font-weight: bold;
}
.table-top-border {
  border-top: 1px solid #000000;
}
</style>
